<template>
    <div>
        <template v-if="!item || !item.id_repasse">

            <div class="card dashcard mb-0">
                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtros" :sync="true" @sync="load()" /> 
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="far fa-building fa-fw"
                                type="select"
                                placeholder="Todas as Unidades..."
                                :optionsList="$util.unidades_com_tags(false, true)"
                                optionsData="id_unidade_operacao"
                                v-model="filtros.id_unidade_operacao" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input
                                type="text"
                                icon="fa fa-search"
                                placeholder="Pesquisar..."
                                v-model="search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" @click="novo_repasse ()">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="progress mt-1 mb-2">
                <div class="indeterminate" v-if="$store.state.loading && lista_repasses.length"></div>
                <div class="determinate" v-else></div>
            </div>

            <az-empty-state 
                :msg="ja_buscou ? 'Nenhum repasse localizado' : 'Buscar Repasses'" 
                icon="fas fa-search" 
                v-if="!lista_repasses.length" 
                :action="ja_buscou ? '' : 'Buscar'"
                :method="load" />

            <template v-else-if="!item || !item.id_repasse">

                <div class="alert alert-info mt-2">
                    Total: {{ $util.formatMoeda(totalGeral(lista_repasses.flatMap(rep => rep.medico_repasses ? rep.medico_repasses : []), 'valor_total')) }}
                </div>

                <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between" v-for="(rep, irx) in lista_repasses" :key="irx">
                        <a href="#" class="card-link" @click.prevent="editar_repasse(rep)">
                            {{ rep.st_titulo }} 
                            <span class="badge badge-secondary ml-3">
                                #{{ rep.id_repasse }}
                            </span>
                            <span class="badge badge-light ml-3" v-if="rep.unidade_operacao && rep.unidade_operacao.st_sigla">
                                {{ rep.unidade_operacao.st_sigla }} 
                            </span>
                        </a>
                        <div>
                            <span class="mr-3">{{ $util.formatMoeda(totalGeral(rep.medico_repasses, 'valor_total')) }}</span>
                            <span class="badge badge-primary mr-2">{{ rep.medico_repasses.length }}</span>
                            {{ rep.periodo }}
                        </div>
                    </li>
                </ul>

            </template>

        </template>

        <template v-else>
            <div class="progress mt-1 mb-1">
                <div class="indeterminate" v-if="$store.state.loading && dados && dados.length"></div>
                <div class="determinate" v-else></div>
            </div>

            <div class="card dashcard">
                <div class="card-header d-flex justify-content-between">
                    <div>
                        {{ item.st_titulo }}
                        <span class="ml-2">#{{ item.id_repasse }}</span>
                    </div>
                    <div class="text-right">
                        {{ item.periodo }}
                        <div v-if="item.unidade_operacao" class="small">
                            {{ item.unidade_operacao.st_nome }}
                        </div>
                    </div>
                </div>
                <template v-if="!medico_repasse && !sociedade_repasse">
                    <div class="card-body">
                        <div class="form-row">
                            <div class="col col-6">
                                <az-input 
                                    sizing="sm"
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    sizing="sm"
                                    type="date"
                                    label="De"
                                    required
                                    :edicao="!item.medico_repasses.length"
                                    :validate="validate"
                                    v-model="item.dt_inicio" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input 
                                    sizing="sm"
                                    type="date"
                                    label="Até"
                                    :edicao="!item.medico_repasses.length"
                                    required
                                    :validate="validate"
                                    v-model="item.dt_termino" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    sizing="sm"
                                    type="textarea"
                                    rows="3"
                                    label="Observações"
                                    v-model="item.st_observacoes" />
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não reter ISS"
                                    v-model="item.fl_nao_reter_iss" />
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <az-submit class="mr-2" @click="salvar_repasse()">Atualizar</az-submit>
                        <az-submit color="outline-danger mr-2" v-if="!item.medico_repasses.length" @click="remover_repasse()">Remover</az-submit>
                        <button type="button" class="btn btn-outline-primary mr-2" @click="incluir_sociedades()" v-if="sociedades && sociedades.length">
                            Incluir Sociedades
                        </button>
                        <button type="button" class="btn btn-outline-primary mr-2" @click="incluir_profissionais()">Incluir Profissionais</button>
                        <button type="button" class="btn btn-secondary" @click="item = null">Fechar</button>
                    </div>
                </template>
            </div>

            <!-- Detalhe do Repasse -->

            <ul class="nav nav-pills" id="myTab" role="tablist" v-show="!medico_repasse && !sociedade_repasse">
                <li class="nav-item" role="presentation" v-if="item.sociedade_repasses.length">
                    <a class="nav-link" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Sociedades</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Profissionais</a>
                </li>
            </ul>

            <div class="tab-content" id="myTabContent">
                
                <div class="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">

                    <div class="card dashcard mt-3" v-if="item.sociedade_repasses && item.sociedade_repasses.length">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item d-flex justify-content-between"
                                v-for="(soc, isx) in item.sociedade_repasses" :key="isx">
                                <a href="#" class="card-link" @click.prevent="editar_sociedade_repasse(soc)">
                                    {{ soc.sociedade_medica.search }}
                                </a>
                                <div class="spinner-border spinner-border-sm ml-2" role="status" v-if="soc.loading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <template v-if="sociedade_repasse">
                        <ul class="nav nav-pills mb-3" id="pills-medico-repasse" role="tablist">
                            <button type="button" class="btn btn-secondary mr-2" @click="sociedade_repasse = null">Voltar</button>
                            <li class="nav-item" role="presentation" v-show="!sociedade_repasse.fl_fechado">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                                    Apuração
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                                    Composição
                                </a>
                            </li>
                        </ul>
                    </template>

                </div>

                <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                    <!-- PROFISSIONAIS INCLUIDOS NO REPASSE -->

                    <div class="form-row mt-3">
                        <div class="col col-12 col-md-3" v-if="$store.state.unidade.unidade_operacaos.length > 1 && !$store.state.user.id_unidade_operacao">
                            <az-input
                                sizing="sm"
                                icon="far fa-building fa-fw"
                                type="select"
                                placeholder="Todas as Unidades..."
                                :optionsList="$util.unidades_com_tags(false, true)"
                                optionsData="id_unidade_operacao"
                                v-model="repasse_id_unidade_operacao" 
                                @input="editar_repasse(item, true)"/>
                        </div>

                        <div class="col col-12 col-md-6">
                            <az-input
                                sizing="sm"
                                icon="fa fa-search fa-fw" 
                                v-model="repasse_search">
                                <template v-slot:buttonposb>
                                    <print-export :dados="dados_lista_medico_repasses" sizing="sm" printid="medico-repasses" />
                                </template>
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="button-group"
                                :optionsList="[
                                    { id: 'T', search: 'Todos' }, 
                                    { id: 'V', search: 'Com Valor' }, 
                                    { id: 'S', search: 'Sem Valor' }, 
                                ]"
                                optionsData="id"
                                v-model="repasse_tipo" />
                        </div>
                    </div>

                    <div id="medico-repasses" v-if="lista_medico_repasses.length">

                        <cabecalho-generico titulo="Repasse" :nome_empresa=" ( item.unidade_operacao && item.unidade_operacao.st_nome ) ? item.unidade_operacao.st_nome : null">
                            <div>#{{ item.id_repasse }}</div>
                            <div>{{ item.st_titulo }}</div>
                            <div>{{ item.periodo }}</div>
                            <div v-if="repasse_id_unidade_operacao">Unidade: {{ $util.unidade_operacao(repasse_id_unidade_operacao).st_nome }}</div>
                            <div v-if="repasse_search">Filtro: {{ repasse_search }}</div>
                            <div v-if="repasse_tipo != 'T'">{{ repasse_tipo == 'V' ? 'COM VALOR' : 'SEM VALOR' }}</div>
                        </cabecalho-generico>

                        <div class="card dashcard mt-3">
                            <ul class="list-group list-group-flush" v-if="!medico_repasse">
                                <li class="list-group-item d-flex justify-content-between list-group-item-primary">
                                    <div>
                                        <strong>TOTAL</strong>
                                    </div>
                                    <div>
                                        <strong>{{ $util.formatMoeda(totalGeral(lista_medico_repasses, "valor_total")) }}</strong>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex justify-content-between" v-for="(mr, imx) in lista_medico_repasses" :key="imx">
                                    <div>
                                        <input type="checkbox" v-model="mr.selec" class="mr-3 d-print-none">

                                        <a href="#" class="card-link" @click.prevent="editar_medico_repasse(mr)">
                                            {{ mr.medico.search }}
                                            <small class="text-muted ml-2">{{ mr.medico.cadastro.st_email }}</small>
                                            <small class="text-muted ml-2" v-if="mr.medico.medico_unidade && mr.medico.medico_unidade.st_email_repasse">
                                                <i class="fa fa-caret-right mr-2" aria-hidden="true"></i>
                                                {{ mr.medico.medico_unidade.st_email_repasse }}
                                            </small>
                                        </a>
                                        <div class="spinner-border spinner-border-sm ml-2" role="status" v-if="mr.loading">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <span class="badge badge-primary mr-2" v-if="mr.arquivos && mr.arquivos.length">
                                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                            {{ mr.arquivos.length }}
                                        </span>
                                        <span v-if="mr.log_envio_emails_count">
                                            <span class="badge mr-2" :class="'badge-' + ( mr.fl_email_enviado ? 'primary': 'secondary' )" >
                                                <i class="fa-regular fa-envelope-open"></i>
                                            </span>
                                        </span>
                                        <span v-if="mr.status_repasse.nome">
                                            <span class="badge mr-2" :class="'badge-' + mr.status_repasse.color" >
                                                {{ mr.status_repasse.nome }}
                                            </span>
                                        </span>
                                        <span v-if="mr.valor_total && mr.valor_total != 0">
                                            {{ $util.formatMoeda(mr.valor_total) }}
                                        </span>
                                        <span v-else-if="!repasse_id_unidade_operacao">
                                            <button type="button" class="btn btn-outline-danger btn-sm" @click="remover_medico_repasse(mr)">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </span>
                                    </div>
                                </li>
                                <li class="list-group-item d-flex justify-content-between list-group-item-primary d-print-none">
                                    <div>
                                        <button type="button" class="btn btn-sm btn-primary mr-3" @click="toggle_mr_all()">
                                            Todos
                                        </button>
                                    </div>
                                    <div class="h5 mb-0">
                                        <span class="badge badge-secondary">
                                            {{ item.medico_repasses.filter(item => item.selec).length }}
                                            /
                                            {{ item.medico_repasses.length }}
                                        </span>
                                    </div>
                                    <div>
                                        <button type="button" class="btn btn-sm btn-outline-danger mr-2"
                                            :disabled="compondo 
                                                || !item.medico_repasses.filter(item => item.selec).length 
                                                || $store.state.loading "
                                            @click="remover_selecionados()">
                                            Remover Produção
                                        </button>
                                        <button type="button" class="btn btn-sm btn-success mr-2"
                                            :disabled="compondo 
                                                || !item.medico_repasses.filter(item => item.selec).length 
                                                || $store.state.loading "
                                            @click="compor_selecionados()">
                                            Compor Selecionados
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary"
                                            :disabled="!item.medico_repasses.filter(item => item.selec).length 
                                                || $store.state.loading "
                                            @click="enviar_solic_nf()">
                                            Enviar Solicitação Selecionados
                                        </button>
                                    </div>
                                </li>
                            </ul>
                            <ul class="list-group list-group-flush" v-else>
                                <li class="list-group-item d-flex justify-content-between">
                                    <div>
                                        {{ medico_repasse.medico.search }}
                                        <small class="text-muted ml-2">{{ medico_repasse.medico.cadastro.st_email }}</small>
                                        <small class="text-muted ml-2" v-if="medico_repasse.medico.medico_unidade && medico_repasse.medico.medico_unidade.st_email_repasse">
                                            <i class="fa fa-caret-right mr-2" aria-hidden="true"></i>
                                            {{ medico_repasse.medico.medico_unidade.st_email_repasse }}
                                        </small>
                                    </div>
                                    <div v-if="medico_repasse.status_repasse.code != 'AB' && medico_repasse.dt_fechamento">
                                        Fechamento: {{ $util.getFormatDate(medico_repasse.dt_fechamento) + ' ' + medico_repasse.dt_fechamento.substr(11,5)  }}
                                    </div>
                                </li>
                            </ul>
                        </div>

                    </div>
               
                    <template v-if="medico_repasse">
                        <ul class="nav nav-pills mb-3" id="pills-medico-repasse" role="tablist">
                            <button type="button" class="btn btn-secondary mr-2" @click="medico_repasse = null">Voltar</button>
                            <li class="nav-item" role="presentation" v-show="!medico_repasse.fl_fechado">
                                <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">
                                    Apuração
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                                    Composição
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">
                                    Anexos
                                </a>
                            </li>
                            <template v-if="false">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="pills-resumo-tab" data-toggle="pill" href="#pills-resumo" role="tab" aria-controls="pills-resumo" aria-selected="false">
                                        Resumo
                                    </a>
                                </li>
                            </template>
                        </ul>
                        <div class="tab-content" id="pills-tabContent">
                            <!-- APURAÇÃO DA PRODUÇÃO -->
                            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" v-show="!medico_repasse.fl_fechado">
                                <div class="mt-3">
                                    <template v-if="medico_repasse">
                                        <repasse-apuracao 
                                            :id_medico_repasse="medico_repasse.id_medico_repasse" 
                                            :medico_repasse="medico_repasse" 
                                            :item="item" 
                                            @compor="compor" />
                                    </template>
                                </div>
                            </div>

                            <!-- COMPOSIÇÃO -->
                            <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">

                                <az-empty-state msg="Nenhum item incluido na composição" icon="far fa-list-alt" v-if="false && !medico_repasse.items.length" />

                                <div class="mt-3" v-else>

                                    <div class="mb-3">
                                        <az-input 
                                            sizing="sm"
                                            type="button-group"
                                            label="Agrupar por..."
                                            :optionsList="[
                                                { id: 'R', search: 'Regra de Rateio' },
                                                { id: 'U', search: 'Unidade' },
                                                { id: 'M', search: 'Mês Produção' },
                                                { id: 'P', search: 'Procedimento' },
                                            ]"
                                            v-model="agrupar_por" />

                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="imp_sintetico = !imp_sintetico; colapsar(!imp_sintetico);">
                                            <i class="fas fa-expand-arrows-alt" v-if="imp_sintetico"></i>
                                            <i class="fas fa-compress-arrows-alt" v-else></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="editar_observacao()">
                                            <i class="fa-solid fa-comment"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-outline-primary ml-1" @click="recalc_percents(medico_repasse)" 
                                            title="Recalcular percentuais"
                                            v-if="medico_repasse 
                                                && ( ( medico_repasse.ajustes && medico_repasse.ajustes.find(aj => aj.dc_perc_ajuste && aj.dc_perc_ajuste > 0) )
                                                || ( medico_repasse.imposto_ajustes && medico_repasse.imposto_ajustes.find(ia => ia.dc_perc_ajuste && ia.dc_perc_ajuste > 0) ) )">
                                            <i class="fa-solid fa-percent"></i>
                                        </button>
                                    </div>

                                    <div id="composicao-repasse">

                                        <cabecalho-generico titulo="Repasse" :nome_empresa=" ( item.unidade_operacao && item.unidade_operacao.st_nome ) ? item.unidade_operacao.st_nome : null">
                                            <div>{{ item.st_titulo }}</div>
                                            <div>{{ medico_repasse.medico.st_nome_exibicao }}</div>
                                            <div>{{ item.periodo }}</div>
                                            <div>{{ medico_repasse.status_repasse.nome }}</div>
                                            <div v-if="medico_repasse.status_repasse.code != 'AB' && medico_repasse.dt_fechamento">
                                                Fechamento: {{ $util.getFormatDate(medico_repasse.dt_fechamento) + ' ' + medico_repasse.dt_fechamento.substr(11,5)  }}
                                            </div>
                                        </cabecalho-generico>

                                        <table class="table table-sm bg-white">
                                            <template v-if="apenas_repasse_produzido(medico_repasse.items)">
                                                <thead>
                                                    <tr>
                                                        <th colspan="5">Descrição</th>
                                                        <th class="text-right">Produzido</th>
                                                        <th class="text-right">Líquido</th>
                                                        <th class="text-right">Repasse</th>
                                                    </tr>
                                                </thead>
                                            </template>
                                            <template v-for="(items, grupo, idx) in agrupar_items(medico_repasse.items)">
                                                <tr :key="idx" class="table-info" v-if="true">
                                                    <td colspan="5">
                                                        <a class="card-link d-print-none" data-toggle="collapse" :href="'#collapse-' + idx">
                                                            {{ grupo }}
                                                            <span class="badge badge-light ml-3 d-print-none">
                                                                {{ items.length }}
                                                            </span>
                                                        </a>
                                                        <span class="d-none d-print-block">
                                                            {{ grupo }}
                                                        </span>
                                                    </td>
                                                    <template v-if="apenas_repasse_produzido(medico_repasse.items)">
                                                        <td class="text-right">
                                                            {{ $util.formatMoeda(total_campo(items, 'total_base')) }}
                                                        </td>    
                                                        <td class="text-right">
                                                            {{ $util.formatMoeda(total_campo(items, 'total_liquido')) }}
                                                        </td>    
                                                    </template>
                                                    <td class="text-right" colspan="3" xcolspan="apenas_repasse_produzido(medico_repasse.items) ? 1 : 3">
                                                        {{ $util.formatMoeda(total_apurado(items)) }}
                                                        <i class="fa fa-plus-circle ml-2 text-success" aria-hidden="true"></i>
                                                    </td>    
                                                </tr>
                                                <tbody :key="'BB' + idx" class="collapse small composicao" :class="imp_sintetico ? 'd-print-none' : ''" :id="'collapse-' + idx" v-if="true">
                                                    <tr>
                                                        <th></th>
                                                        <table-th title="Id" v-model="ordem_comp" sortby="atendimento_procedimento.id_atendimento"></table-th>
                                                        <table-th title="Data" v-model="ordem_comp" sortby="dt_referencia"></table-th>
                                                        <table-th title="Paciente" v-model="ordem_comp" sortby="atendimento_procedimento.atendimento.paciente.st_nome"></table-th>
                                                        <table-th title="Procedimento" v-model="ordem_comp" sortby="atendimento_procedimento.procedimento.search"></table-th>
                                                        <th>Regra</th>
                                                        <th class="text-right">
                                                            <span :class="medico_repasse.suprimir_valor_impressao ? 'd-print-none' : ''">
                                                                Valor
                                                            </span>
                                                        </th>
                                                        <th class="text-right">Repasse</th>
                                                    </tr>
                                                    <template v-for="(item, iix) in ordenar(items, ordem_comp)">
                                                        <tr :key="'L' + idx + '.' + iix" v-if="true">
                                                            <td>
                                                                <a href="#" class="card-link text-danger d-print-none" @click.prevent="remover_item(item)"
                                                                    v-if="!medico_repasse.fl_fechado">
                                                                    <i class="far fa-minus-square"></i>
                                                                </a>
                                                            </td>
                                                            <td>#{{ item.atendimento_procedimento.id_atendimento }}
                                                                <span class="badge badge-light ml-2" v-if="item.atendimento_procedimento.atendimento.unidade_operacao_nome && item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_sigla">
                                                                    {{ item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_sigla }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <a href="#" class="card-link" @click.prevent="$router.push({ name: 'recepcao', params: { parmdata: item.atendimento_procedimento.atendimento.dt_inicio.substr(0,10) } })">
                                                                    {{ $util.getFormatDate(item.atendimento_procedimento.atendimento.dt_inicio) }}
                                                                </a>
                                                                <div v-if="item.ch_tipo_repasse && item.ch_tipo_repasse != 'P' && item.dt_referencia" class="d-print-none">
                                                                    <span class="badge" :class="item.ch_tipo_repasse == 'F' ? 'badge-primary' : 'badge-success'">
                                                                        {{ item.ch_tipo_repasse }}
                                                                    </span>
                                                                    <small v-if="item.dt_referencia">
                                                                        {{ $util.getFormatDate(item.dt_referencia) }}
                                                                    </small>
                                                                </div>
                                                                <span v-else-if="item.ch_tipo_repasse && item.ch_tipo_repasse != 'P'" class="d-print-none">
                                                                    <span class="badge" :class="item.ch_tipo_repasse == 'F' ? 'badge-primary' : 'badge-success'">
                                                                        {{ item.ch_tipo_repasse }}
                                                                    </span>
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>{{ item.atendimento_procedimento.atendimento.paciente.st_nome }}</span>
                                                                
                                                                <small class="text-muted ml-2" v-if="item.atendimento_procedimento.plano_particular">{{ item.atendimento_procedimento.plano_particular.search }}</small>
                                                                <small class="text-muted ml-2" v-else>{{ item.atendimento_procedimento.atendimento.plano.search }}</small>

                                                                <small class="text-muted ml-2" v-if="item.forma_pagamento">{{ item.forma_pagamento.search }}</small>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {{ item.atendimento_procedimento.procedimento.search }}
                                                                    <span v-if="item.atendimento_procedimento.in_quantidade" class="badge badge-secondary ml-2">
                                                                        x{{ item.atendimento_procedimento.in_quantidade }}
                                                                    </span>
                                                                </span>
                                                                <span class="text-muted ml-2" v-if="item.atendimento_procedimento_equipe && item.atendimento_procedimento_equipe.grau_participacao">
                                                                    {{ item.atendimento_procedimento_equipe.grau_participacao.st_grau_participacao }}
                                                                </span>
                                                                <small class="text-muted ml-2" v-if="item.atendimento_procedimento.numero_sessao">
                                                                    {{ item.atendimento_procedimento.numero_sessao }}/{{ item.atendimento_procedimento.total_sessao }}
                                                                </small>
                                                                <span class="badge badge-warning ml-1">{{ item.st_observacoes }}</span>
                                                            </td>
                                                            <td class="text-muted">
                                                                <a href="#" class="card-link" v-if="item.id_rateio_medico"
                                                                    @click.prevent="ver_criterio(item.id_rateio_medico)">
                                                                    #{{ item.id_rateio_medico }}
                                                                </a>
                                                                <a href="#" class="card-link" v-else
                                                                    @click.prevent="ver_criterio(item.atendimento_procedimento.id_rateio_medico)">
                                                                    #{{ item.atendimento_procedimento.id_rateio_medico }}
                                                                </a>
                                                            </td>
                                                            <td class="text-right text-muted">
                                                                <span :class="medico_repasse.suprimir_valor_impressao ? 'd-print-none' : ''">
                                                                    {{ $util.formatMoeda(item.dc_valor_base) }}
                                                                </span>
                                                            </td>
                                                            <td class="text-right text-nowrap">
                                                                {{ $util.formatMoeda(item.dc_valor_apurado) }}
                                                            </td>
                                                        </tr>
                                                        <template v-if="item.js_detalhe_consumo && item.js_detalhe_consumo.length">
                                                            <template v-if="!exibir_matmed_consolidado">
                                                                <tr v-for="(consumo, icx) in item.js_detalhe_consumo" :key="'C' + idx + '.' + iix + '.' + icx">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td class="text-muted">{{ consumo.search }}
                                                                        <span class="badge badge-secondary" v-if="consumo.qtd > 1">
                                                                            x{{ consumo.qtd }}
                                                                        </span>
                                                                    </td>
                                                                    <td></td>
                                                                    <td class="text-right text-muted">
                                                                        <span :class="medico_repasse.suprimir_valor_impressao ? 'd-print-none' : ''">
                                                                            {{ $util.formatMoeda(consumo.base) }}
                                                                        </span>
                                                                    </td>
                                                                    <td class="text-right" :class="!item.dc_valor_consumo ? 'text-muted' : ''">
                                                                        <span :class="!item.dc_valor_consumo ? 'mr-2' : ''">{{ $util.formatMoeda(consumo.rateio) }}</span>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-else>
                                                                <tr :key="'CC' + idx + '.' + iix">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td class="text-muted">
                                                                        Mat/Med/Taxas
                                                                    </td>
                                                                    <td></td>
                                                                    <td class="text-right text-muted"></td>
                                                                    <td class="text-right">
                                                                        {{ $util.formatMoeda(totalizar(item.js_detalhe_consumo, 'rateio')) }}
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </template> 
                                                </tbody>
                                            </template>
                                            <tr class="table-primary">
                                                <td colspan="5">
                                                    <strong>TOTAL REPASSE</strong>
                                                </td>
                                                <td colspan="3" class="text-right">
                                                    <strong>
                                                        {{ $util.formatMoeda(total_apurado(medico_repasse.items)) }}
                                                        <i class="fas fa-circle text-primary ml-2"></i>
                                                    </strong>
                                                </td>
                                            </tr>
                                            <!-- Ajustes -->
                                            <template v-if="medico_repasse.ajustes.length">
                                                <tr v-for="(aj, ijx) in medico_repasse.ajustes" :key="'ajuste' + ijx">
                                                    <td colspan="5">
                                                        <a href="#" class="card-link" @click.prevent="editar_ajuste(aj)" v-if="medico_repasse.status_repasse.code == 'AB'">
                                                            {{ aj.st_ajuste }}
                                                        </a>
                                                        <span v-else>
                                                            {{ aj.st_ajuste }}
                                                        </span>

                                                        <span class="badge badge-light ml-1" v-if="aj.unidade_operacao">
                                                            {{ aj.unidade_operacao.st_sigla }}
                                                        </span>
                                                    </td>
                                                    <td class="text-right" colspan="3">
                                                        {{ $util.formatMoeda(aj.dc_valor_ajuste) }}
                                                        <i class="fa fa-minus-circle ml-2 text-danger" aria-hidden="true" v-if="aj.fl_abater"></i>
                                                        <i class="fa fa-plus-circle ml-2 text-success" aria-hidden="true" v-else></i>
                                                    </td>
                                                </tr>
                                                <tr class="table-primary">
                                                    <td colspan="5">
                                                        <strong>TOTAL</strong>
                                                    </td>
                                                    <td colspan="3" class="text-right">
                                                        <strong>
                                                            {{ $util.formatMoeda(total_final(medico_repasse)) }}
                                                            <i class="fas fa-circle text-primary ml-2"></i>
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-if="medico_repasse.imposto_ajustes && medico_repasse.imposto_ajustes.length">
                                                <tr v-for="(aj, ijx) in medico_repasse.imposto_ajustes" :key="'imp_ajuste' + ijx">
                                                    <td colspan="5">
                                                        <a href="#" class="card-link" @click.prevent="editar_ajuste(aj)" v-if="medico_repasse.status_repasse.code == 'AB'">
                                                            {{ aj.st_ajuste }}
                                                        </a>
                                                        <span v-else>
                                                            {{ aj.st_ajuste }}
                                                        </span>

                                                        <span class="badge badge-light ml-1" v-if="aj.unidade_operacao">
                                                            {{ aj.unidade_operacao.st_sigla }}
                                                        </span>

                                                        <template v-if="total_final(medico_repasse) > 0">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ $util.formatMoeda( ( aj.dc_valor_ajuste / total_final(medico_repasse) ) * 100 ) }}%
                                                        </template>
                                                    </td>
                                                    <td class="text-right" colspan="3">
                                                        {{ $util.formatMoeda(aj.dc_valor_ajuste) }}
                                                        <i class="fa fa-minus-circle ml-2 text-danger" aria-hidden="true" v-if="aj.fl_abater"></i>
                                                        <i class="fa fa-plus-circle ml-2 text-success" aria-hidden="true" v-else></i>
                                                    </td>
                                                </tr>
                                                <tr v-if="medico_repasse.imposto_ajustes && medico_repasse.imposto_ajustes.length" class="table-primary">
                                                    <td colspan="5">
                                                        <strong>RESULTADO LÍQUIDO</strong>
                                                    </td>
                                                    <td colspan="3" class="text-right">
                                                        <strong>
                                                            <span>{{ $util.formatMoeda(total_final(medico_repasse, true)) }}</span>
                                                            <i class="fas fa-circle text-primary ml-2"></i>
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else-if="1 == 0 && medico_repasse.medico.fornecedor">
                                                <template v-for="(imposto, iix) in medico_repasse.medico.fornecedor.retencoes">
                                                    <tr :key="'imp' + iix" v-if="imposto.imposto.search.slice(0,2) != 'IR' || ( ( total_final(medico_repasse) * ( imposto.dc_aliquota / 100 ) ) >= 10 )">
                                                        <td colspan="5">
                                                            {{ imposto.imposto.search }}
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            {{ $util.formatMoeda(imposto.dc_aliquota) }}%
                                                        </td>
                                                        <td colspan="3" class="text-right">
                                                            <strong>
                                                                <span>{{ $util.formatMoeda(total_final(medico_repasse) * ( imposto.dc_aliquota / 100 ) ) }}</span>
                                                                <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true"></i>
                                                            </strong>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <tr v-if="medico_repasse.medico.fornecedor.retencoes.length" class="table-primary">
                                                    <td colspan="5">
                                                        <strong>RESULTADO LÍQUIDO</strong>
                                                    </td>
                                                    <td colspan="3" class="text-right">
                                                        <strong>
                                                            <span>{{ $util.formatMoeda(total_final(medico_repasse, true)) }}</span>
                                                            <i class="fas fa-circle text-primary ml-2"></i>
                                                        </strong>
                                                    </td>
                                                </tr>
                                            </template>
                                        </table>

                                        <div class="alert alert-info" style="white-space: pre-wrap;" v-if="medico_repasse.st_observacoes">{{ medico_repasse.st_observacoes }}</div>

                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12">
                                            <az-input 
                                                sizing="sm"
                                                type="checkbox-group" 
                                                label="Consolidar Mat/Med/Taxas"
                                                v-model="exibir_matmed_consolidado" />
                                        </div>
                                    </div>

                                    <!-- Ações -->
                                    <div class="d-flex mt-3">

                                        <template v-if="medico_repasse.status_repasse.code == 'AB'">
                                            
                                            <button type="button" class="btn btn-outline-primary mr-2" @click="incluir_ajuste()">Incluir Ajuste</button>
                                            <button type="button" class="btn btn-outline-primary mr-2" 
                                                v-if="medico_repasse.medico && medico_repasse.medico.fornecedor && medico_repasse.medico.fornecedor.retencoes && medico_repasse.medico.fornecedor.retencoes.length
                                                    && medico_repasse.imposto_ajustes && !medico_repasse.imposto_ajustes.length"
                                                @click="incluir_impostos()">
                                                Incluir Impostos
                                            </button>

                                            <az-submit color="outline-danger mr-2" @click="remover_producao()">Remover Produção</az-submit>
                                            
                                            <az-submit @click="fechar_medico_repasse(medico_repasse)" class="mr-2">
                                                Fechar Composição
                                            </az-submit>

                                        </template>

                                        <template v-if="medico_repasse.status_repasse.code == 'FC'">
                                            <az-submit color="outline-danger mr-2" @click="fechar_medico_repasse(medico_repasse)">
                                                Reabrir Composição
                                            </az-submit>
                                            <az-submit color="outline-primary mr-2" @click="enviar_solic_nf(medico_repasse)" v-if="medico_repasse.valor_total > 0">
                                                {{ medico_repasse.fl_email_enviado ? 'Re-enviar' : 'Enviar' }} 
                                                Solicitação de Nota Fiscal
                                            </az-submit>
                                            <az-submit @click="gerar_lancamento(medico_repasse)" class="mr-2">
                                                Gerar Lançamento para Pagamento
                                            </az-submit>
                                        </template>

                                        <template v-if="medico_repasse.status_repasse.code == 'LG'">
                                            <span class="mr-3">
                                                Lançamento gerado no financeiro para pagamento: #{{ medico_repasse.id_lancamento }}
                                            </span>

                                            <az-submit color="outline-primary ml-2" @click="enviar_solic_nf(medico_repasse)" v-if="medico_repasse.valor_total > 0 && anexo_livre">
                                                {{ medico_repasse.fl_email_enviado ? 'Re-enviar' : 'Enviar' }}
                                                Solicitação de Nota Fiscal
                                            </az-submit>

                                            <az-submit color="outline-danger mx-2" @click="cancelar_lancamento(medico_repasse)">
                                                Cancelar Lançamento para Pagamento
                                            </az-submit>
                                        </template>

                                        <span class="mr-2">
                                            <az-audit-log-button model="medicoRepasse" :id="medico_repasse.id_medico_repasse" />
                                        </span>

                                        <print-export :dados="composicao_exportacao" printid="composicao-repasse" @beforeprint="colapsar(!imp_sintetico)" >
                                            <template v-slot:dropdownitem>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" href="#" @click="imp_sintetico = true">
                                                    <i class="fa fa-check-circle-o fa-fw mr-2" v-if="imp_sintetico"></i>
                                                    <i class="fa fa-circle-o fa-fw mr-2" v-else></i>
                                                    Sintético
                                                </a>
                                                <a class="dropdown-item" href="#" @click="imp_sintetico = false">
                                                    <i class="fa fa-check-circle-o fa-fw mr-2" v-if="!imp_sintetico"></i>
                                                    <i class="fa fa-circle-o fa-fw mr-2" v-else></i>
                                                    Analítico
                                                </a>

                                                <relatorios-linkados
                                                    class="ml-1"
                                                    :apenas_links="true"
                                                    pagina="repasse-profissional"
                                                    :parms="{ 
                                                        repasse_profissional_id: medico_repasse.id_medico_repasse, 
                                                    }" />
                                            </template>
                                        </print-export>
                                    </div>

                                    <template v-if="medico_repasse.status_repasse.code == 'PG'">
                                        <div class="alert alert-info mt-3">
                                            Repasse pago (#{{ medico_repasse.id_lancamento }})
                                        </div>
                                    </template>

                                    <template v-if="medico_repasse.log_envio_emails && medico_repasse.log_envio_emails.length">
                                        <table class="table bg-white mt-3">
                                            <thead>
                                                <tr>
                                                    <th>Envio e-mail</th>
                                                    <th>Responsável</th>
                                                    <th>Destinatário</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(envio, iex) in medico_repasse.log_envio_emails" :key="iex">
                                                    <td>
                                                        {{ $util.getFormatDate(envio.created_at) }}
                                                        {{ envio.created_at.slice(11,16) }}
                                                    </td>
                                                    <td>{{ envio.usuario ? envio.usuario.st_login : '' }}</td>
                                                    <td>{{ envio.st_destinatario }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    

                                </div>

                                <template v-if="false">
                                    <pre class="alert alert-warning mt-3">{{ composicao_exportacao }}</pre>
                                    <pre class="alert alert-danger mt-3">{{ medico_repasse.items }}</pre>
                                    <pre class="alert alert-warning mt-3">{{ medico_repasse }}</pre>
                                    <pre class="mt-3">{{ agrupar_items(medico_repasse.items) }}</pre>
                                </template>
                            </div>

                            <!-- Ajustes -->
                            <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">

                                <div class="mt-3">
                                    <div class="card dashcard">
                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item" v-for="(arq, iax) in medico_repasse.arquivos" :key="iax">
                                                <a :href="arq.arquivo.temporary_url" target="_blank" class="card-link">
                                                    {{ arq.arquivo.st_titulo }}
                                                </a>
                                            </li>
                                        </ul>
                                        <div class="card-footer">
                                            <button class="btn btn-outline-primary" @click="anexar()">Anexar</button>
                                        </div>
                                    </div>
                                    
                                    <pre v-if="false">{{ medico_repasse.arquivos }}</pre>

                                    <az-file-upload
                                        ref="upload"
                                        @refresh="refresh_medico_repasse()"
                                        :multiple="true"
                                        :arquivos="medico_repasse.arquivos"
                                        :parms="{ model_type: 'medicoRepasse', model_id: medico_repasse.id_medico_repasse }" />

                                </div>

                            </div>

                            <div class="tab-pane fade" id="pills-resumo" role="tabpanel" aria-labelledby="pills-resumo-tab">
                                Resumo
                            </div>
                        </div>
                    </template>

                    <az-empty-state 
                        class="mt-3"
                        v-if="!lista_medico_repasses.length" 
                        msg="Nenhum profissional relacionado." 
                        action="Incluir Profissionais" 
                        :method="incluir_profissionais"/>

                 </div>

            </div>
 
        </template>

        <!-- Modal -->
        <div class="modal fade" id="mrObsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao_obs">
                    <div class="modal-header">
                        <h5 class="modal-title">Observação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            Essa observação será exibida no relatório de repasse e no e-mail enviado.
                        </div>

                        <az-input
                            label="Observação"
                            type="textarea"
                            rows="6"
                            v-model="edicao_obs.st_observacoes" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_observacoes()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- INCLUIR PROFISSIONAIS -->
        <div class="modal fade" id="incluirProfissionaisModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog  modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Profissionais: {{ item ? item.st_titulo : 'Carregando...' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        
                        <div class="mb-3">
                            <az-input 
                                icon="fa fa-search fa-fw" 
                                placeholder="Pesquisar..."
                                v-model="search_medico" />

                            <az-input 
                                icon="fas fa-filter fa-fw" 
                                type="select" 
                                optionsMode="esp-ativas"
                                optionsName="esp-ativas"
                                :optionsReload="true"
                                placeholder="Especialidade..."
                                v-model="especialidade" />

                            <az-input
                                icon="fa fa-calendar-o fa-fw" 
                                placeholder="Todos os Profissionais..."
                                type="select" 
                                :optionsList="[
                                    { id: 'P', search: 'Repasse pelo Produzido' }, 
                                    { id: 'F', search: 'Repasse pelo Faturado' }, 
                                    { id: 'R', search: 'Repasse pelo Recebido' },
                                ]"
                                optionsData="id"
                                v-model="tipo_rateio" />
                        </div>

                        <table class="table table-sm border-0 table-responsive">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="filtrar_medico(classe)" v-for="(classe, icx) in lista_medico_classes" :key="icx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <az-empty-state v-if="!lista_medicos || !lista_medicos.length" msg="Nenhum profissional identificado." />

                        <div v-else>

                            <az-input
                                type="checkbox-group"
                                label="TODOS"
                                v-model="todos"
                                @click="trocando_medico = true;" />

                            <div v-for="(medico, idx) in lista_medicos" :key="idx">
                                <az-input 
                                    type="checkbox-group"
                                    :label="medico.search"
                                    v-model="medico.selecionado" />
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_profissionais()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- INCLUIR SOCIEDADES -->
        <div class="modal fade" id="incluirSociedadesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog  modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Sociedades: {{ item ? item.st_titulo : 'Carregando...' }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <az-input 
                                icon="fa fa-search fa-fw" 
                                placeholder="Pesquisar..."
                                v-model="search_sociedade" />
                        </div>

                        <az-empty-state v-if="!lista_sociedades || !lista_sociedades.length" msg="Nenhuma sociedade identificada." />

                        <div v-else>
                            <az-input
                                type="checkbox-group"
                                label="TODOS"
                                v-model="todas_sociedades" />

                            <div v-for="(sociedade, idx) in lista_sociedades" :key="idx">
                                <az-input 
                                    type="checkbox-group"
                                    :label="sociedade.search"
                                    v-model="sociedade.selecionado" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_sociedades()">Incluir</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- CRIAR REPASSE -->
        <div class="modal fade" id="repasseModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Repasse</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    v-model="item.st_titulo"
                                    :validate="validate" />
                            </div>

                            <div class="col col-12">
                                <az-input
                                    label="Unidade"
                                    type="select"
                                    :optionsList="$util.unidades_com_tags(true, true)"
                                    optionsData="id_unidade_operacao"
                                    placeholder="Todas as Unidades..."
                                    :edicao="!$store.state.user.id_unidade_operacao"
                                    v-model="item.id_unidade_operacao" />
                            </div>

                            <div class="col col-12">
                                <az-input
                                    type="date"
                                    label="De"
                                    v-model="item.dt_inicio"
                                    required 
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="date"
                                    label="Até"
                                    v-model="item.dt_termino"
                                    required 
                                    :validate="validate" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    rows="4"
                                    label="Observação"
                                    v-model="item.st_observacoes"
                                    :validate="validate" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_repasse()">
                            {{ item.id_repasse ? 'Atualizar' : 'Incluir' }}
                        </az-submit>                        
                    </div>
                </div>
            </div>
        </div>

        <edicao-rateio-medico ref="cadrateio" :viewonly="true" />

        <!-- Modal -->
        <div class="modal fade" id="gerarLancamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content" v-if="novo_lanc.selecionado && novo_lanc.exibir">
                    <div class="modal-header">
                        <h5 class="modal-title">Gerar Lançamento para Pagamento</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            type="select"
                            label="Unidade"
                            required
                            :validate="validate"
                            :optionsList="$store.state.unidade.unidade_operacaos"
                            optionsData="id_unidade_operacao"
                            v-model="novo_lanc.unidade" />
                        
                        <az-input
                            type="date"
                            label="Vencimento"
                            required
                            :validate="validate"
                            v-model="novo_lanc.vencimento" />

                        <az-input
                            label="Categoria"
                            required
                            :validate="validate"
                            type="select"
                            optionsMode="aql"
                            service="categorias.index"
                            :optionsName="'categorias.' + ( novo_lanc ? novo_lanc.tipo : 'X' )"
                            optionsData="id_categoria"
                            optionsDisplay="search"
                            :optionsParm="{ lancamento: true, where: { ch_natureza: novo_lanc.tipo } }"
                            v-model="novo_lanc.categoria" />

                        <az-input
                            label="Observação"
                            v-model="novo_lanc.observacoes" />

                        <!-- Adiantamento -->
                        <div v-if="novo_lanc.fornecedor && novo_lanc.dc_valor > 0 && novo_lanc.tipo == 'D' && novo_lanc.fornecedor.adiantamentos && novo_lanc.fornecedor.saldo_adiantamentos">

                            <div class="small text-muted mt-3">
                                {{ novo_lanc.fornecedor.st_nome_fantasia }}
                                / #{{ novo_lanc.fornecedor.id_fornecedor }}
                            </div>

                            <saldo-adiantamento 
                                :fornecedor="novo_lanc.fornecedor" 
                                :valor="novo_lanc.dc_valor_uso_adiantamento" 
                                :edicao="true"
                                v-if="novo_lanc && novo_lanc.fornecedor" 
                                @usar="utilizar_ad" />

                            <az-input
                                :type="trocando_valor_ad ? 'number' : 'money'"
                                label="Valor Adiantado"
                                :validate="validate"
                                v-model="novo_lanc.dc_valor_uso_adiantamento" />
                        </div>

                        <pre v-if="false">{{ novo_lanc }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="confirmar_gerar_lancamento(medico_repasse)">Gerar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="ajusteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="ajuste">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajuste</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-input
                            class="mt-3"
                            label="Imposto"
                            type="checkbox-group"
                            :validate="validate"
                            v-model="ajuste.fl_imposto" 
                            v-if="!ajuste.id_ajuste_repasse"
                            @click="ajuste.id_imposto = ''; ajuste.fl_abater = true;" />

                        <az-input
                            label="Descrição"
                            required
                            :validate="validate"
                            v-model="ajuste.st_ajuste" 
                            v-if="!ajuste.fl_imposto" />

                        <az-input
                            label="Imposto"
                            type="select"
                            service="impostos.index"
                            optionsMode="aql"
                            optionsData="id_imposto"
                            optionsDisplay="search"
                            :optionsParm="{ 
                                natureza: 'D'
                            }"
                            optionsName="impostos.natd"
                            required
                            :validate="validate"
                            placeholder="Selecione o Imposto..."
                            v-model="ajuste.id_imposto"
                            :edicao="!ajuste.id_ajuste_repasse"
                            v-if="ajuste.fl_imposto" />

                        <az-input
                            label="Percentual"
                            type="money"
                            v-model="ajuste.dc_perc_ajuste">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <i class="fa-solid fa-percent"></i>
                                    </span>
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                        title="Calcular Valor"
                                        data-toggle="tooltip"
                                        @click="calcular_ajuste_perc()">
                                        <i class="fa-solid fa-arrow-down"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Valor"
                            :type="editando_valor_ajuste ? 'number' : 'money'"
                            required
                            :validate="validate"
                            v-model="ajuste.dc_valor_ajuste">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                        :disabled="ajuste.fl_imposto"
                                        @click="ajuste.fl_abater = !ajuste.fl_abater">
                                        <i class="fas fa-plus-circle text-success" v-if="!ajuste.fl_abater"></i>        
                                        <i class="fas fa-minus-circle text-danger" v-else></i>        
                                    </button>
                                </div>
                            </template>
                        </az-input>

                        <az-input
                            label="Unidade"
                            type="select"
                            :required="!ajuste.fl_imposto"
                            :validate="validate"
                            :optionsList="$util.unidades_com_tags(false,true)"
                            optionsData="id_unidade_operacao"
                            v-model="ajuste.id_unidade_operacao" />

                        <az-input
                            label="Observação"
                            :validate="validate"
                            v-model="ajuste.st_observacoes" />
                    </div>
                    <div class="modal-footer">
                        <az-submit color="danger" @click="remover_ajuste()" v-if="ajuste.id_ajuste_repasse">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_ajuste()">{{ ajuste.id_ajuste_repasse ? 'Atualizar' : 'Incluir'}}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="apuroModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Apurar Produção</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="medico_repasse && medico_repasse.corte_faturamento">
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Produção De"
                                        v-model="apuro.inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Produção Até"
                                        v-model="apuro.fim" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Faturado De"
                                        v-model="apuro.fat_inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Faturado Até"
                                        required
                                        :validate="validate"
                                        v-model="apuro.fat_fim" />
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="De"
                                        v-model="apuro.inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Até"
                                        v-model="apuro.fim" />
                                </div>
                            </div>

                            <div class="row" v-if="!apuro.produzido && !apuro.faturado && apuro.recebido">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Atendido de"
                                        v-model="apuro.atd_inicio" />
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        type="date"
                                        label="Atendido até"
                                        v-model="apuro.atd_fim" />
                                </div>
                            </div>
                        </template>
                        
                        <az-sub-title class="mt-3" title="Incluir rateios..." />

                        <az-input
                            type="checkbox-group"
                            label="por produção"
                            v-model="apuro.produzido" />

                        <az-input
                            type="checkbox-group"
                            label="por faturamento"
                            v-model="apuro.faturado" />

                        <az-input
                            type="checkbox-group"
                            label="por recebimento"
                            v-model="apuro.recebido" />

                        <filtro-model class="mt-3" v-model="apuro.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="buscar_apuracao()">Apurar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <repasse-apuracao 
            ref="apura_mult"
            :mult="true"
            :item="item" 
            @compor="compor_selecionados" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import EdicaoRateioMedico from '../../cadastros/shared/EdicaoRateioMedico.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';
import TableTh from '../../shared/table/TableTh.vue';
import PrintExport from '../../shared/PrintExport.vue';
import RepasseApuracao from './RepasseApuracao.vue';
import { subscribe, unSubscribe } from "../../../service/Notify";
import SaldoAdiantamento from '../financeiro/SaldoAdiantamento.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import RelatoriosLinkados from "../../relatorios/shared/RelatoriosLinkados.vue";

export default {
    data() { 
        return {
            filtros: { 
                inicio: "",
                fim: "", 
                periodo: "m", 
                mes: "", 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao ? this.$store.state.user.id_unidade_operacao : '', 
            },
            from: "",
            to: "", 
            dados: [], 
            abrindo: true,
            search: "", 
            search_medico: "", 
            validate: false, 
            item: null, 
            repasse: null, 
            medicos: [], 
            especialidade: "", 
            medico_repasse: null, 
            apuracao: null, 
            novo_lanc: { 
                unidade: "", 
                vencimento: "",
                categoria: "",
                observacoes: "",
                selecionado: false, 
                tipo: "D", 
                exibir: false, 
                dc_valor_uso_adiantamento: 0,
                fornecedor: null, 
            },
            ajuste: null, 
            teste: null,
            search_apuracao: "",
            apuro: { 
                inicio: "",
                fim: "",
                produzido: true,
                faturado: true,
                recebido: true,
                filtros: [], 
                atd_inicio: "",
                atd_fim: "", 
            },
            sociedades: [], 
            search_sociedade: "", 
            sociedade_repasse: null, 
            tipo_rateio: "", 
            ordem_comp: "", 
            agrupar_por: 'R', 
            imp_sintetico: false, 
            compondo: false, 
            evento_subscribe: "",
            comp_exibir_prod: false,
            repasse_id_unidade_operacao: "", 
            repasse_tipo: "T", 
            repasse_search: "", 
            ja_buscou: false, 
            edicao_obs: null, 
            trocando_medico: false, 
            trocando_valor_ad: false, 
            anexo_livre: false, 
            editando_valor_ajuste: false, 
            exibir_matmed_consolidado: false, 
         }
    },

    components: { 
        AzEmptyState,
        AzInput,
        AzPeriodo, 
        AzSubmit,
        EdicaoRateioMedico,
        AzFileUpload,
        CabecalhoGenerico,
        AzSubTitle,
        FiltroModel,
        TableTh,
        PrintExport,
        RepasseApuracao, 
        SaldoAdiantamento,
        AzAuditLogButton, 
        RelatoriosLinkados, 
    },

    /*
    watch: { 
        filtros: {
            handler: function () {
                this.load ();
            },
            deep: true,
            immediate: true
        }
    },
    */

    computed: { 
        lista_medico_classes: function () { 
            if ( !this.lista_medicos )
                return [];

            return _.uniq(
                    this.lista_medicos.flatMap(item => item.js_classes ? item.js_classes : [])
                ).sort();
        },

        lista_medico_repasses: function () { 
            if ( !this.item )
                return [];

            const reg = this.$util.getregex(this.repasse_search);

            return this.item.medico_repasses.filter(mr => this.repasse_tipo == 'T'
                    || ( this.repasse_tipo == 'V' && mr.valor_total > 0 )
                    || ( this.repasse_tipo == 'S' && !( mr.valor_total > 0 ) )
                )
                .filter(mr => !this.repasse_search || reg.test(JSON.stringify(mr)) );
        },

        dados_lista_medico_repasses: function () { 
            return this.lista_medico_repasses.map(mr => { 
                return { 
                    nome: mr.medico.st_nome_exibicao, 
                    email: mr.medico.cadastro ? mr.medico.cadastro.st_email : '', 
                    valor: this.$util.formatMoeda(mr.valor_total),
                };
            });
        },

        composicao_exportacao: function () { 
            if ( !this.medico_repasse || !this.medico_repasse.items ) { 
                return [];
            }
            
            return this.medico_repasse.items.flatMap(item => { 

                let lista = [];

                lista.push({ 
                    id: item.atendimento_procedimento.id_atendimento, 
                    unidade: item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome,
                    data_de_atendimento: item.atendimento_procedimento.atendimento.dt_inicio, 
                    paciente: item.atendimento_procedimento.atendimento.paciente.st_nome,
                    plano: item.atendimento_procedimento.atendimento.plano.search, 
                    procedimento: item.atendimento_procedimento.procedimento.search, 
                    qtde: item.atendimento_procedimento.in_quantidade,
                    regra: item.atendimento_procedimento.id_rateio_medico,
                    valor: this.$util.formatMoeda(item.dc_valor_base),
                    repasse: this.$util.formatMoeda(item.dc_valor_apurado),
                    data_ref: item.dt_referencia ? this.$util.getFormatDate(item.dt_referencia) : '',
                });

                if ( item.js_detalhe_consumo && item.js_detalhe_consumo.length ) { 

                    let consumos = []; 

                    if ( !this.exibir_matmed_consolidado ) { 

                        consumos = item.js_detalhe_consumo.map(consumo => { 
                            return { 
                                id: item.atendimento_procedimento.id_atendimento, 
                                unidade: item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome,
                                data_de_atendimento: item.atendimento_procedimento.atendimento.dt_inicio, 
                                paciente: item.atendimento_procedimento.atendimento.paciente.st_nome,
                                plano: item.atendimento_procedimento.atendimento.plano.search, 
                                procedimento: consumo.search, 
                                qtde: consumo.qtd,
                                regra: item.atendimento_procedimento.id_rateio_medico,
                                valor: this.$util.formatMoeda(consumo.base),
                                repasse: this.$util.formatMoeda(consumo.rateio),
                                data_ref: item.dt_referencia ? this.$util.getFormatDate(item.dt_referencia) : '',
                            };
                        });
                        
                    } else { 

                        consumos = [{ 
                            id: item.atendimento_procedimento.id_atendimento, 
                            unidade: item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome,
                            data_de_atendimento: item.atendimento_procedimento.atendimento.dt_inicio, 
                            paciente: item.atendimento_procedimento.atendimento.paciente.st_nome,
                            plano: item.atendimento_procedimento.atendimento.plano.search, 
                            procedimento: 'Mat/Med/Taxas', 
                            qtde: '',
                            regra: item.atendimento_procedimento.id_rateio_medico,
                            valor: this.$util.formatMoeda(this.totalizar(item.js_detalhe_consumo, 'base')),
                            repasse: this.$util.formatMoeda(this.totalizar(item.js_detalhe_consumo, 'rateio')),
                            data_ref: item.dt_referencia ? this.$util.getFormatDate(item.dt_referencia) : '',
                        }];

                    }

                    lista = lista.concat(consumos);

                }
   
                return lista;

            });
        },

        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\formaPagamento', search:'Forma de Pagamento', service: 'forma_pagamentos.index', nosync: true},
                // {id:'App\\azure\\fatura', search:'Fatura', service: 'faturas.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'});
            }
            
            return opcoes;
        },

        lista_apuracao: function () { 
            if ( !this.apuracao )
                return [];

            let pesquisar = this.search_apuracao.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.apuracao.filter (item => ( !this.search_apuracao || reg.test(JSON.stringify(item)) ));
        },

        lista_repasses: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => ( item.fl_ativo || ( item.medico_repasses && item.medico_repasses.length )))
                    .filter (item => ( !this.search || reg.test(JSON.stringify(item)) )) : [];

        },

        todos_marcacao: { 
            get() {
                if ( !this.apuracao )
                    return false;

                return this.apuracao.findIndex(atp => !atp.selecionado) < 0;
            },
            set(value) {
                this.apuracao.forEach(element => {
                    element.selecionado = value;
                });
            }
        },

        todos: { 
            get() {
                return this.lista_medicos.findIndex(item => !item.selecionado) < 0;
            },
            set(value) {
                if ( this.trocando_medico ) { 
                    this.lista_medicos.forEach(element => {
                        element.selecionado = value;
                    });

                    this.trocando_medico = false;
                }
            }
        },

        todas_sociedades: { 
            get() {
                return this.lista_sociedades.findIndex(item => !item.selecionado) < 0;
            },
            set(value) {
                this.lista_sociedades.forEach(element => {
                    element.selecionado = value;
                });
            }
        },

        selecionados: function () { 
            if ( !this.apuracao )
                return [];

            return this.lista_apuracao.filter(item => item.selecionado);
        },

        lista_medicos: function() { 
            if ( !this.medicos )
                return this.medicos ? this.medicos : [];

            let pesquisar = this.search_medico.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.medicos.filter (item => ( !this.search_medico || reg.test(JSON.stringify(item)) ))
                .filter(medico => !this.tipo_rateio || medico.tipo_rateio_medicos.find(trm => trm.ch_tipo_repasse == this.tipo_rateio))
                .filter(
                    medico => medico.medico_especialidade.findIndex(
                        esp => !this.especialidade || esp.id_especialidade == this.especialidade.id_especialidade) >= 0
                    );
        },

        lista_sociedades: function() { 
            if ( !this.sociedades )
                return this.sociedades ? this.sociedades : [];

            let pesquisar = this.search_sociedade.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.sociedades.filter (item => ( !this.search_sociedade || reg.test(JSON.stringify(item)) ));
        },
    },

    methods: { 
        recalc_percents (medico_repasse) { 

            if ( medico_repasse.ajustes ) { 

                medico_repasse.ajustes.forEach(ajuste => { 
                    if ( ajuste.dc_perc_ajuste && ajuste.dc_perc_ajuste > 0 ) { 
                        ajuste.dc_valor_ajuste = Math.round(this.total_apurado(medico_repasse.items) * ( ajuste.dc_perc_ajuste )) / 100;
                        this.salvar_ajuste(ajuste);
                    }
                });

            }

            if ( medico_repasse.imposto_ajustes ) { 

                medico_repasse.imposto_ajustes.forEach(ajuste => { 
                    if ( ajuste.dc_perc_ajuste && ajuste.dc_perc_ajuste > 0 ) { 
                        ajuste.dc_valor_ajuste = Math.round(this.total_final(medico_repasse) * ( ajuste.dc_perc_ajuste )) / 100;
                        this.salvar_ajuste(ajuste);
                    }
                });

            }

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Percentuais recalculados com sucesso.",
                life: 6000
            });

        },

        totalizar (lista, campo) { 
            if ( !lista || !lista.length )
                return 0;

            return lista.reduce((total, item) => { 
                return total + ( _.get(item, campo) ? parseFloat(_.get(item, campo)) : 0 );
            }, 0);
        },

        calcular_ajuste_perc () { 
            this.editando_valor_ajuste = true; 

            this.$nextTick(() => { 
                let valor_base = this.ajuste.fl_imposto 
                    ? this.total_final(this.medico_repasse, true, true)
                    : this.total_apurado(this.medico_repasse.items);

                this.ajuste.dc_valor_ajuste = Math.round(valor_base * ( this.ajuste.dc_perc_ajuste )) / 100;
                this.editando_valor_ajuste = false; 
            })
        },

        remover_selecionados () { 

            if ( !confirm('Confirma remover a produção dos profissionais selecionados?') ) { 
                return;
            }

            this.compondo = true;

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'remover_mult',
                dados: { 
                    lista: this.lista_medico_repasses.filter(item => item.selec && item.valor_total)
                        .map(item => { 
                            return { 
                                id_medico_repasse: item.id_medico_repasse
                            }
                        }),
                },
                callback: () => { 
                    if ( this.item ) { 
                        this.editar_repasse(this.item);
                    }
                }
            });

        },

        incluir_impostos () {

            if ( !confirm('Confirma realizar a inclusão dos impostos?') ) { 
                return;
            }
            
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'incluir_impostos',
                dados: { 
                    id_medico_repasse: this.medico_repasse.id_medico_repasse, 
                    lista: this.medico_repasse.medico.fornecedor.retencoes.map(imposto => { 
                        return { 
                            id_imposto: imposto.id_imposto, 
                            aliquota: imposto.dc_aliquota, 
                            valor: this.total_final(this.medico_repasse) * ( imposto.dc_aliquota / 100 )
                        }
                    })
                },
                toast: true,
                callback: () => { 
                    this.refresh_medico_repasse();
                }
            });

        },

        filtrar_medico (classe) { 
            if ( this.search_medico == '"' + classe + '"' ) { 
                this.search_medico = "";
            } else { 
                this.search_medico = '"' + classe + '"';
            }
        },
        
        editar_observacao() { 
            this.edicao_obs = _.cloneDeep(this.medico_repasse);
            $('#mrObsModal').modal('show');
        },

        salvar_observacoes() { 
            this.$util.atualizar(this, { 
                service: 'medico_repasses',
                func: 'salvar_observacao', 
                dados: this.edicao_obs, 
                callback: () => { 
                    this.refresh_medico_repasse();
                }
            });
        },

        apenas_repasse_produzido (items) {
            if ( !this.comp_exibir_prod )
                return false;

            return items.find(item => item.ch_tipo_repasse != 'P'
                && item.ch_tipo_repasse != 'M'
                && item.ch_tipo_repasse != 'F') ? false : true;
        },

        compor_selecionados (filtros = null) { 

            if ( !filtros ) {
                this.$refs.apura_mult.selecionar_apuracao();
                return;
            }

            this.compondo = true;

            let lista_filtros = _.cloneDeep(filtros);

            lista_filtros.filtros.forEach(item => {
                if ( item.model && item.model.forma_pagamento ) { 
                    item.model.forma_pagamento = null;
                }
            });

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'compor_mult',
                dados: { 
                    lista: this.lista_medico_repasses.filter(item => item.selec) // && !item.valor_total)
                        .map(item => item.id_medico_repasse),
                    filtros: lista_filtros, 
                },
                toast: true,
                msg: 'Composição em andamento.'
            });

            this.evento_subscribe = "repasse-compor-mult-" + this.$store.state.user.id_usuario;

            subscribe(this.$store.state.dominio, this.evento_subscribe, 
                (retorno) => {
                    if ( this.item ) { 
                        this.editar_repasse(this.item);
                    }

                    if ( retorno.data.fim ) { 
                        unSubscribe(this.$store.state.dominio, this.evento_subscribe);
                        this.evento_subscribe = "";
                        this.compondo = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 6000
                        });
                    } else if ( retorno.data.mensagem ) { 

                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: retorno.data.mensagem,
                            life: 5000
                        });

                    }

                }
            );

        },

        toggle_mr_all () { 
            let opcao = this.item.medico_repasses.find(item => item.selec) ? false : true;

            this.item.medico_repasses.forEach(item => { 
                item.selec = opcao
            });
        },

        abrir_atendimento (atp) { 
            this.$util.abrir_atendimento(this, atp.id_atendimento);
        },

        ordenar (lista, ordem) { 

            let items = lista;

            if ( ordem ) { 
                this.$util.setCookie('rep_ord_cp', ordem.name);

                items = _.sortBy(items, (item) => { 
                    return _.get(item, ordem.name );
                });

                if ( ordem.direction == 'desc' ) {
                    items = _.reverse(items); 
                }
            } 

            return items;
        },

        ajuste_data_fim () { 
            this.to = this.$util.ultimo_dia_mes(this.from);
        },

        colapsar (abrir) { 
             $('.composicao').collapse(abrir ? 'show' : 'hide');
        },

        imprimir_composicao() { 
            $('.composicao').collapse('show');

            this.$nextTick(() => { 
                this.$htmlToPaper('composicao-repasse', null, () => {
                    console.log("Printing");
                });
            });
        },

        remover_producao() { 
            if ( !confirm ('Confirma remover todos os itens de produção da composição do repasse desse profissional?') )
                return; 

            this.$util.atualizar (this, { 
                service: 'repasses',
                func:  'remover_composicao',
                dados: { 
                    id_medico_repasse: this.medico_repasse.id_medico_repasse,
                },
                callback: () => { 
                    this.refresh_medico_repasse();
                }
            });
        },

        remover_repasse() { 
            if ( !confirm ('Confirma remover esse repasse?') )
                return; 

            this.$util.remover (this, { 
                service: 'repasses',
                dados: this.item,
                callback: () => { 
                    this.item = null;
                    this.load();
                }
            });
        },

        remover_ajuste() { 
            this.$util.atualizar (this, { 
                service: 'repasses',
                func: 'remover_ajuste',
                dados: this.ajuste,
                modal: 'ajusteModal',
                callback: () => { 
                    this.refresh_medico_repasse();
                }
            });
        },

        editar_ajuste(aj) { 
            this.validate = false;
            this.ajuste = null;

            this.$nextTick(() => {
                this.ajuste = _.cloneDeep(aj);
                $('#ajusteModal').modal('show');
            });
        },

        remover_medico_repasse(mr) { 
            this.$util.remover (this, { 
                service: 'medico_repasses',
                dados: mr,
                callback: () => { 
                    this.editar_repasse(mr);
                }
            });
        },

        salvar_ajuste(ajuste = null) { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'salvar_ajuste',
                dados: ajuste || this.ajuste, 
                modal: 'ajusteModal',
                callback: () => { 
                    if ( !ajuste ) { 
                        this.refresh_medico_repasse();
                    }
                }
            });
        },

        incluir_ajuste() { 
            this.validate = false;
            this.ajuste = null;
            this.compondo = false; 

            this.$nextTick(() => {
                this.ajuste = { 
                    id_ajuste_repasse: null, 
                    id_medico_repasse: this.medico_repasse.id_medico_repasse,
                    st_ajuste: "",
                    fl_ativo: true, 
                    fl_abater: true, 
                    dc_valor_ajuste: 0,
                    st_observacoes: "", 
                    id_unidade_operacao: this.item.id_unidade_operacao, 
                };

                $('#ajusteModal').modal('show');
            });
        },

        anexar() { 
            this.$refs.upload.abrir();
        },

        cancelar_lancamento (medico_repasse) { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'cancelar_lancamento',
                dados: { 
                    id_medico_repasse: medico_repasse.id_medico_repasse, 
                },
                toast: true,
                callback: () => { 
                    this.apuracao = null; 
                    this.refresh_medico_repasse(medico_repasse);
                } 
            });
        },

        utilizar_ad (valor) { 
            this.trocando_valor_ad = true;

            this.$nextTick(() => { 
                this.novo_lanc.dc_valor_uso_adiantamento = ( valor > this.novo_lanc.dc_valor ) ? this.novo_lanc.dc_valor : valor;
                this.trocando_valor_ad = false;
            });
        },

        gerar_lancamento () { 
            this.validate = false; 
            this.novo_lanc.exibir = false;

            this.$nextTick(() => { 
                this.novo_lanc.selecionado = true;
                this.novo_lanc.observacoes = "";
                this.novo_lanc.tipo = ( this.medico_repasse.valor_total < 0 ? 'C' : 'D' );
                this.novo_lanc.exibir = true;
                this.novo_lanc.fornecedor = null; 
                this.novo_lanc.dc_valor = this.total_apurado(this.medico_repasse.items);
                this.novo_lanc.dc_valor_uso_adiantamento = 0;

                if ( _.get(this.medico_repasse, 'medico.fornecedor.id_fornecedor') ) { 
                
                    this.$util.loadItem(this, { 
                        service: 'fornecedores',
                        func: 'show',
                        parms: { 
                            id: this.medico_repasse.medico.fornecedor.id_fornecedor,
                            tipo_lanc: 'A',
                        },
                    })
                    .then(res => { 
                        console.log('res', res);
                        this.novo_lanc.fornecedor = res;

                        console.log('novo_lanc', this.novo_lanc);
                    });

                }

                //console.log('mr', this.medico_repasse);
                $('#gerarLancamentoModal').modal('show');
            });
        },

        confirmar_gerar_lancamento(medico_repasse) { 

            if ( this.novo_lanc && this.novo_lanc.fornecedor && this.novo_lanc.fornecedor.adiantamentos && this.novo_lanc.fornecedor.saldo_adiantamentos ) { 

                if ( this.novo_lanc.dc_valor_uso_adiantamento && this.novo_lanc.dc_valor_uso_adiantamento > this.novo_lanc.dc_valor ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "O valor a ser utilizado do adiantamento não pode ser maior que o valor do lançamento.",
                        life: 5000
                    });

                    return;
                }

                if ( this.novo_lanc.dc_valor_uso_adiantamento && Math.round(this.novo_lanc.dc_valor_uso_adiantamento * 100) > Math.round(this.novo_lanc.fornecedor.saldo_adiantamentos * 100) ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Saldo adiantado insuficiente. " 
                            + '\n Saldo: ' + this.$util.formatMoeda(this.novo_lanc.fornecedor.saldo_adiantamentos)
                            + '\n Uso: ' + this.$util.formatMoeda(this.novo_lanc ? this.novo_lanc.dc_valor_uso_adiantamento : 0),
                        life: 5000
                    });

                    return;
                }

            }

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'gerar_lancamento',
                dados: { 
                    id_medico_repasse: medico_repasse.id_medico_repasse, 
                    ...this.novo_lanc, 
                },
                modal: 'gerarLancamentoModal',
                callback: () => { 
                    this.apuracao = null; 
                    this.refresh_medico_repasse(medico_repasse);
                } 
            });

        },

        remover_item (item_repasse) { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'remover_item',
                dados: { 
                    id_item_repasse: item_repasse.id_item_repasse, 
                    lista: item_repasse.remocao, 
                },
                toast: true,
                callback: res => { 
                    this.apuracao = null; 

                    if ( res && res.id_item_repasse && !res.fl_ativo )
                        item_repasse.fl_ativo = false;

                    this.refresh_medico_repasse(this.medico_repasse);

                    // this.editar_repasse(this.medico_repasse);
                } 
            });
        },

        fechar_medico_repasse(medico_repasse) { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'toggle_composicao',
                dados: { 
                    id_medico_repasse: medico_repasse.id_medico_repasse, 
                },
                toast: true,
                callback: res => { 
                    medico_repasse.fl_fechado = res.fl_fechado;
                    this.refresh_medico_repasse(medico_repasse);

                    this.$nextTick(() => { 
                        $('#pills-medico-repasse a[href="#pills-home"]').tab('dispose');
                    });
                } 
            });
        },

        ver_criterio(id_rateio_medico) { 
            this.$refs.cadrateio.editar(id_rateio_medico);
        },

        enviar_solic_nf(medico_repasse = null) { 
            if ( !medico_repasse ) { 

                if ( !this.item.medico_repasses.filter(mr => mr.selec).length ) { 
                    this.$toast.add({ 
                        severity: "error",
                        summary: "Atenção",
                        detail: "Selecione os profissionais desejados.",
                        life: 6000
                    });
                    return;
                }

                if ( !confirm('Confirma enviar e-mail com solicitação de NF para os profissionais selecionados com repasse fechado?') ) { 
                    return;
                }

            }

            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'solicitar_nota_fiscal',
                dados: { 
                    id_repasse: this.item.id_repasse,
                    lista: medico_repasse 
                        ? [medico_repasse.id_medico_repasse]
                        : this.item.medico_repasses.filter(mr => mr.selec).map(mr => mr.id_medico_repasse)
                },
                callback: () => { 
                    if ( !medico_repasse ) { 
                        this.editar_repasse (this.item);
                    }
                } 
            });
        },

        total_apurado (items) { 
            return this.total_campo(items, 'total');
        },

        total_campo (items, campo) { 
            return _.sumBy(items.filter(item => item.fl_ativo), campo);
        },

        total_final (medico_repasse, liquido = false, sem_impostos = false) { 
            return this.total_apurado(medico_repasse.items) + medico_repasse.ajustes.reduce((total, carry) => { 
                    return total + ( carry.dc_valor_ajuste * ( carry.fl_abater ? -1 : 1 ) );
                }, 0)
                + ( liquido 
                    ? medico_repasse.imposto_ajustes.reduce((total, carry) => { 
                            return total + ( carry.dc_valor_ajuste * ( carry.fl_abater ? -1 : 1 ) );
                        }, 0)
                    : 0 
                )
                - ( ( liquido && !sem_impostos && !medico_repasse.imposto_ajustes.length )  
                    ? medico_repasse.medico.fornecedor.retencoes
                        .filter(ret => ret.imposto.search.slice(0,2) != 'IR' || ( ( this.total_final(medico_repasse) * ( ret.dc_aliquota / 100 ) ) >= 10 ) )
                        .reduce((total, carry) => { 
                            return total + ( Math.round( this.total_final(medico_repasse) * ( carry.dc_aliquota ) ) / 100 ); 
                        }, 0)
                    : 0 );
        },

        agrupar_items (items) { 
            return _.groupBy(
                _.orderBy(
                    items.filter(item => item.fl_ativo),
                    item => { 
                        if ( this.agrupar_por == 'U' ) { 
                            return item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome;
                        } else if ( this.agrupar_por == 'M' ) { 
                            return item.atendimento_procedimento.atendimento.dt_inicio.substr(0,7);
                        } else if ( this.agrupar_por == 'P' ) { 
                            return item.atendimento_procedimento.procedimento.search;
                        } else { 
                            let titulo = item.st_regra_titulo ? ' / ' + item.st_regra_titulo : '';
                            return item.rateio_medico.search + titulo;
                        }
                    }    
                ), 
                item => { 
                    if ( this.agrupar_por == 'U' ) { 
                        return item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome;
                    } else if ( this.agrupar_por == 'M' ) { 
                        return item.atendimento_procedimento.atendimento.dt_inicio.substr(0,7);
                    } else if ( this.agrupar_por == 'P' ) { 
                        return item.atendimento_procedimento.procedimento.search;
                    } else { 
                        let titulo = item.st_regra_titulo ? ' / ' + item.st_regra_titulo : '';
                        return item.rateio_medico.search + titulo;
                    }
                }
            );
        },

        compor (lista = null) { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'compor',
                dados: { 
                    id_medico_repasse: this.medico_repasse.id_medico_repasse, 
                    lista: lista,
                },
                toast: true, 
                callback: () => { 
                    this.refresh_medico_repasse(this.medico_repasse);
                    $('#pills-medico-repasse a[href="#pills-profile"]').tab('show');
                },
            });
        },

        refresh_medico_repasse(medico_repasse = null, refresh_repasse = true) { 

            $('.modal').modal('hide');

            if ( !medico_repasse )
                medico_repasse = this.medico_repasse;

            this.editar_medico_repasse(medico_repasse);

            if ( refresh_repasse )
                this.editar_repasse(medico_repasse);

        },

        totalGeral(lista, campo, selecioando = false) { 
            if ( !lista )
                return 0;

            //if ( campo == 'valor_base' )
                // console.log('VB', lista);
            
            return lista.reduce((total, carry) => { 
                return total + ( ( selecioando && !carry.selecionado ) ? 0 : ( !isNaN(carry[campo]) ? carry[campo] : 0 ) );
            }, 0);
        },

        valorTotal(atend) { 
            return atend.atendimento_procedimentos.reduce((total, carry) => { 
                return total + carry.valor_total;
            }, 0);
        },

        valorRateio(atend) { 
            return atend.atendimento_procedimentos.reduce((total, carry) => total + carry.valor_base_rateio, 0);
        },

        selecionar_apuracao() { 
            this.apuro.inicio = this.item.dt_inicio;
            this.apuro.fim = this.item.dt_termino;
            this.validate = false;

            $('#apuroModal').modal('show');
        },

        buscar_apuracao() { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'apuracao',
                dados: { 
                    id_medico_repasse: this.medico_repasse.id_medico_repasse, 
                    ...this.apuro, 
                },
                callback: res => {
                    this.teste = res;
                    this.apuracao = res.apuracao;    
                    $('#apuroModal').modal('hide');
                },
            });
        },

        editar_sociedade_repasse(sr) { 
            sr.loading = true;
            this.apuracao = null;

            this.$util.load(this, { 
                service: 'sociedade_repasses',
                func: 'show',
                parms: { 
                    id: sr.id_sociedade_repasse, 
                },
                loadTo: res => { 
                    this.sociedade_repasse = res;        
                    
                    /*
                    if ( this.sociedade_repasse.fl_fechado ) { 
                        this.$nextTick(() => { 
                            // $('#pills-medico-repasse a[href="#pills-profile"]').tab('show');
                        });
                    }
                    */
                },
                final: () => { 
                    sr.loading = false;
                }
            });
        },

        editar_medico_repasse(mr) { 
            mr.loading = true;
            this.apuracao = null;

            this.$util.load(this, { 
                service: 'medico_repasses',
                func: 'show',
                parms: { 
                    id: mr.id_medico_repasse, 
                    composicao: true, 
                },
                loadTo: res => { 
                    this.medico_repasse = res; 

                    this.comp_exibir_prod = res.exibir_prod;

                    if ( this.medico_repasse.fl_fechado ) { 
                        this.$nextTick(() => { 
                            $('#pills-medico-repasse a[href="#pills-profile"]').tab('show');
                        });
                    }
                },
                final: () => { 
                    mr.loading = false;
                }
            });
        },

        salvar_profissionais() { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'incluir_profissionais',
                dados: { 
                    id_repasse: this.item.id_repasse, 
                    medicos: this.lista_medicos.filter(item => item.selecionado),
                },
                modal: 'incluirProfissionaisModal',
                callback: () => { 
                    this.load_medicos();
                    this.editar_repasse(this.item);
                },
            });
        },

        salvar_sociedades() { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'incluir_sociedades',
                dados: { 
                    id_repasse: this.item.id_repasse, 
                    sociedades: this.lista_sociedades.filter(item => item.selecionado),
                },
                modal: 'incluirSociedadesModal',
                callback: () => { 
                    this.load_medicos();
                    this.editar_repasse(this.item);
                },
            });
        },

        incluir_profissionais() { 
            this.medicos.forEach(medico => { 
                medico.selecionado = false;
            });

            this.$nextTick(() => { 
                $('#incluirProfissionaisModal').modal('show');
            });
        },

        incluir_sociedades() { 
            this.sociedades.forEach(sociedade => { 
                sociedade.selecionado = false;
            });

            this.$nextTick(() => { 
                $('#incluirSociedadesModal').modal('show');
            });
        },

        editar_repasse(item, filtro = false) { 
            
            this.validate = false;
            this.compondo = false; 

            if ( !filtro ) { 
                this.repasse_id_unidade_operacao = ""; 
                this.repasse_tipo = "T";
                this.repasse_search = ""; 
            }

            this.$util.load(this, { 
                service: 'repasses',
                func: 'show',
                parms: { 
                    id: item.id_repasse, 
                    edicao: true, 
                    id_unidade_operacao: this.repasse_id_unidade_operacao
                },
                loadTo: res => { 
                    this.item = res;
                }
            });

        },

        salvar_repasse() { 
            this.$util.atualizar(this, { 
                service: 'repasses',
                func: 'store',
                dados: this.item,
                modal: 'repasseModal',
                reload: true 
            });
        },

        novo_repasse() { 
            this.validate = false;

            this.item = { 
                id_repasse: null, 
                fl_ativo: true, 
                dt_inicio: "",
                dt_termino: "", 
                st_observacoes: "", 
                id_unidade_operacao: this.$store.state.user.id_unidade_operacao ? this.$store.state.user.id_unidade_operacao : '', 
            };

            this.$nextTick(() => { 
                $('#repasseModal').modal('show');
            });
        },
        
        load_medicos() { 

            // this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'medicos.index',
                        id: "medicos",
                        parms: {
                            ativos: true, 
                            load_tipo_rateio: true
                        }
                    },
                    {
                        name: 'sociedades_medicas.index',
                        id: "sociedades",
                        parms: {
                            where: { fl_ativo: true }, 
                        }
                    },
                ]
            };

            this.axios.post("/aql?a=medicos-repasse", query)
                .then(res => {
                        if (res.data.medicos.status == 200) {
                            this.medicos = res.data.medicos.data.map(medico => { 
                                medico.selecionado = false;
                                return medico;
                            });
                        }

                        if (res.data.sociedades.status == 200) {
                            this.sociedades = res.data.sociedades.data.map(item => { 
                                item.selecionado = false;
                                return item;
                            });
                        }
                    })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
            
        },

        load() { 
            if ( this.abrindo )
                return;

            this.ja_buscou = true;

            this.$util.load(this, { 
                id: 'repasse',
                service: 'repasses',
                func: 'index',
                parms: { 
                    ...this.filtros,  
                    search: this.search, 
                    lista: true, 
                },
                configs: [
                    'repasse-prestador-anexo-livre'
                ], 
                loadTo: res => { 
                    this.dados = res;
                    this.anexo_livre = this.$store.state.contexto['repasse-prestador-anexo-livre'] == 1;                   
                }
            });
        },
    },

    created() { 
        const hoje = this.$util.hoje().substr(0,7);

        this.from = hoje + '-01';
        this.to = moment(hoje + '-01').endOf('month').format('YYYY-MM-DD');
    },

    beforeDestroy () { 
        if ( this.evento_subscribe ) { 
            unSubscribe(this.$store.state.dominio, this.evento_subscribe);
            this.evento_subscribe = "";
        }
    },

    mounted() { 
        const ord = this.$util.getCookie('rep_ord_cp');

        if ( ord ) { 
            this.ordem_comp = { 
                name: ord,
                direction: "asc",
            };
        }

        this.$store.commit("setBreadcrumb", [
            { name: "Repasse", path: "" },
            { name: "Registro", path: "/repasse/repasses" }
        ]);

        this.$nextTick(() => { 
            this.abrindo = false;
            
            if ( this.$route.params.search ) { 

                const ids = this.$route.params.search.match(/#[0-9]+/gi);

                if ( ids ) { 
                    this.search = ids[0];
                    this.load();
                }

            }
        });

        this.load_medicos();

    }
}
</script>